import React from "react";

function ByIcon({ color, className }) {
  return (
    <svg
      viewBox="0 0 478.04932 478.04932"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs id="defs6">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath16">
          <path d="M 0,358.537 H 358.537 V 0 H 0 Z" id="path14" />
        </clipPath>
      </defs>
      <g id="g8" transform="matrix(1.3333333,0,0,-1.3333333,0,478.04933)">
        <g id="g10">
          <g id="g12" clipPath="url(#clipPath16)">
            <g id="g18" transform="translate(22.2227,266.2109)">
              <path
                d="M 0,0 V -0.444 C 0.082,-0.296 0.166,-0.148 0.249,0 Z"
                style={{
                  fill: "#ffffff",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path20"
              />
            </g>
            <g id="g22" transform="translate(75.9497,32.7568)">
              <path
                d="M 0,0 C -22.136,15.639 -40.565,36.168 -53.727,60.014"
                style={{
                  fill: "#ffffff",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path24"
              />
            </g>
            <g id="g26" transform="translate(0,179.2686)">
              <path
                d="M 0,0 C 0,-31.369 8.065,-60.85 22.223,-86.498 V 86.498 C 8.065,60.85 0,31.368 0,0"
                style={{
                  fill: color || "currentColor",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path28"
              />
            </g>
            <g id="g30" transform="translate(137.0249,103.1084)">
              <path
                d="m 0,0 c 0,12.25 -7,22.75 -16.8,25.9 -5.95,2.1 -12.601,2.8 -23.801,2.8 h -16.45 v -55.651 h 18.55 C -11.55,-26.951 0,-18.9 0,0"
                style={{
                  fill: color || "currentColor",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path32"
              />
            </g>
            <g id="g34" transform="translate(120.5742,179.4092)">
              <path
                d="m 0,0 c 5.95,3.5 9.45,11.551 9.45,19.951 0,16.45 -9.1,23.45 -31.5,23.45 h -18.551 v -47.6 h 18.551 c 11.9,0 17.5,1.049 22.05,4.199"
                style={{
                  fill: color || "currentColor",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path36"
              />
            </g>
            <g id="g38" transform="translate(247.2686,128.6592)">
              <path
                d="M 0,0 -71.051,137.552 H -9.8 L 24.5,62.301 c 3.851,-10.5 3.851,-11.201 5.601,-15.75 4.2,11.55 4.2,12.25 5.6,15.75 l 35.351,75.251 h 17.745 c -30.596,55.06 -89.34,92.325 -156.797,92.325 -67.457,0 -126.201,-37.265 -156.797,-92.325 h 84.803 c 34.3,0 46.551,-2.801 60.201,-14.35 14.35,-11.551 22.4,-28.701 22.4,-46.901 0,-24.151 -11.2,-40.951 -33.251,-50.051 24.151,-4.9 39.901,-27.301 39.901,-55.651 0,-18.901 -7,-36.05 -19.25,-48.301 -13.3,-12.601 -29.751,-18.2 -55.301,-18.2 h -46.025 c 29.203,-20.632 64.844,-32.757 103.319,-32.757 38.475,0 74.115,12.125 103.318,32.757 H 0 Z"
                style={{
                  fill: color || "currentColor",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path40"
              />
            </g>
            <g id="g42" transform="translate(305.0195,128.6592)">
              <path
                d="m 0,0 v -77.14 c 33.03,32.517 53.518,77.738 53.518,127.749 0,14.472 -1.727,28.539 -4.965,42.018 z"
                style={{
                  fill: color || "currentColor",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path44"
              />
            </g>
            <g id="g46" transform="translate(79.9736,76.1572)">
              <path
                d="m 0,0 v 55.651 h 16.45 c 11.2,0 17.851,-0.7 23.801,-2.799 9.8,-3.151 16.8,-13.651 16.8,-25.901 C 57.051,8.051 45.501,0 18.55,0 Z m 0,146.653 h 18.55 c 22.401,0 31.501,-7 31.501,-23.45 0,-8.4 -3.5,-16.451 -9.45,-19.951 -4.55,-3.15 -10.15,-4.199 -22.051,-4.199 H 0 Z M 97.302,-25.2 c 12.25,12.251 19.25,29.4 19.25,48.301 0,28.35 -15.75,50.751 -39.901,55.651 22.051,9.1 33.251,25.9 33.251,50.051 0,18.2 -8.05,35.35 -22.401,46.901 -13.649,11.549 -25.9,14.35 -60.2,14.35 h -84.803 c -0.083,-0.149 -0.167,-0.296 -0.249,-0.445 V 16.613 C -44.589,-7.232 -26.16,-27.762 -4.024,-43.4 h 46.025 c 25.55,0 42,5.599 55.301,18.2"
                style={{
                  fill: "#ffffff",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path48"
              />
            </g>
            <g id="g50" transform="translate(353.5723,221.2861)">
              <path
                d="m 0,0 c -3.82,15.906 -9.76,30.985 -17.507,44.925 h -17.745 l -35.351,-75.251 c -1.4,-3.5 -1.4,-4.2 -5.6,-15.75 -1.75,4.549 -1.75,5.25 -5.601,15.75 l -34.3,75.251 h -61.251 l 71.051,-137.552 v -95.902 h 35.319 c 7.985,5.641 15.484,11.922 22.432,18.762 v 77.14 z"
                style={{
                  fill: "#ffffff",
                  fillOpacity: 1,
                  fillRule: "nonzero",
                  stroke: "none",
                }}
                id="path52"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ByIcon;
